import {create} from 'zustand';

const useSupportSeekerModal = create((set) => ({
  isOpen: false,
  open: () => set({isOpen: true}),
  close: () => set({isOpen: false}),
}));


export default useSupportSeekerModal;